interface PartnerSiteLinkProps {
  /** Same destination as the section's button. */
  href: string;
  /** Link text. Defaults to the domain of `href`, without `www.`. */
  label?: string;
  /** `dark` for sections with a dark background. */
  tone?: "light" | "dark";
}

const TONE_CLASSES = {
  light: { text: "text-gray-700", link: "text-ink-900" },
  dark: { text: "text-gray-200", link: "text-white" },
} as const;

export function partnerSiteLabel(href: string): string {
  return new URL(href).hostname.replace(/^www\./, "");
}

/** "Visit example.org" line shown under a partner's buttons. */
export function PartnerSiteLink({ href, label, tone = "light" }: PartnerSiteLinkProps) {
  const colors = TONE_CLASSES[tone];
  return (
    <p className={`mt-5 text-base ${colors.text}`} data-testid="partner-site-link">
      Visit{" "}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`font-semibold underline underline-offset-2 hover:no-underline ${colors.link}`}
      >
        {label ?? partnerSiteLabel(href)}
      </a>
    </p>
  );
}
